import { z } from 'zod';
import { safeRetrieve, safeStore } from '../../utils/storage';
import { createDefaultSerializableScene, SerializableSceneSchema, } from './Scene';
const SCENES_LOCALSTORAGE_KEY = 'scenes';
const LIVE_SCENE_ID_LOCALSTORAGE_KEY = 'liveSceneId';
const DISPLAY_SCENE_ID_LOCALSTORAGE_KEY = 'displaySceneId';
const SCENE_THUMBNAILS_LOCALSTORAGE_KEY = 'sceneThumbnails';
export class SceneStore {
    scenes = [];
    liveSceneId;
    displaySceneId;
    thumbnails = {};
    constructor() {
        const scenesFromLocalStorage = safeRetrieve(SCENES_LOCALSTORAGE_KEY, (raw) => {
            const parsed = z.array(SerializableSceneSchema).safeParse(raw);
            return parsed.success ? parsed.data : [];
        });
        const scenes = Array.isArray(scenesFromLocalStorage)
            ? scenesFromLocalStorage
            : [];
        if (scenes.length > 0) {
            this.setScenes(scenes);
        }
        else {
            this.setScenes([createDefaultSerializableScene()]);
        }
        this.liveSceneId = safeRetrieve(LIVE_SCENE_ID_LOCALSTORAGE_KEY, (raw) => {
            const parsed = z.string().safeParse(raw);
            return parsed.success ? parsed.data : undefined;
        });
        this.displaySceneId = safeRetrieve(DISPLAY_SCENE_ID_LOCALSTORAGE_KEY, (raw) => {
            const parsed = z.string().safeParse(raw);
            return parsed.success ? parsed.data : undefined;
        });
        this.thumbnails =
            safeRetrieve(SCENE_THUMBNAILS_LOCALSTORAGE_KEY, (raw) => {
                const parsed = z
                    .record(z.string(), z.string())
                    .safeParse(raw);
                return parsed.success ? parsed.data : {};
            }) ?? {};
    }
    getScenes() {
        return this.scenes;
    }
    addScene(scene) {
        this.setScenes([...this.scenes, scene]);
    }
    updateScene(scene) {
        this.setScenes(this.scenes.map((s) => (s.id === scene.id ? scene : s)));
    }
    deleteScene(id) {
        this.setScenes(this.scenes.filter((s) => s.id !== id));
    }
    getLiveSceneId() {
        return this.liveSceneId;
    }
    setLiveSceneId(id) {
        this.liveSceneId = id;
        safeStore(LIVE_SCENE_ID_LOCALSTORAGE_KEY, id);
    }
    getDisplaySceneId() {
        return this.displaySceneId;
    }
    setDisplaySceneId(id) {
        this.displaySceneId = id;
        safeStore(DISPLAY_SCENE_ID_LOCALSTORAGE_KEY, id);
    }
    getThumbnails() {
        return this.thumbnails;
    }
    setThumbnail(sceneId, dataUrl) {
        this.thumbnails = { ...this.thumbnails, [sceneId]: dataUrl };
        safeStore(SCENE_THUMBNAILS_LOCALSTORAGE_KEY, this.thumbnails);
    }
    removeThumbnail(sceneId) {
        const { [sceneId]: _, ...rest } = this.thumbnails;
        this.thumbnails = rest;
        safeStore(SCENE_THUMBNAILS_LOCALSTORAGE_KEY, this.thumbnails);
    }
    setScenes(scenes) {
        this.scenes = scenes;
        safeStore(SCENES_LOCALSTORAGE_KEY, this.scenes);
    }
}
